import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import DashboardDiscoverModeOfferActionPass from './components/OfferActions/DashboardDiscoverModeOfferActionPass';
import DashboardDiscoverModeOfferActionInput from './components/OfferActions/DashboardDiscoverModeOfferActionInput';
import DashboardDiscoverModeOfferActionOffer from './components/OfferActions/DashboardDiscoverModeOfferActionOffer';
import { updateShowTutorialOffer } from '../../../actions/profileActions';
import { connect } from 'react-redux';
import { useDashboardDiscoverMode } from '../../../contexts/DashboardDiscoverModeContext';
import { useApp } from '../../../contexts/AppContext';
import borders from '../../../theme/borders';
import DashboardDiscoverModeWhatsAnOffer from './components/DashboardDiscoverModeWhatsAnOffer';
import { ProfileMaker } from '../../../models/Profile';
import { Props } from './types/DashboardDiscoverModeOfferActions';
import { AppDispatch, RootState } from '../../../store';
import breakpoints from '../../../theme/material/breakpoints';
import { MEDIA_SCREEN_HEIGHT_300_450 } from './styles/media';
import useMediaBreakpoints from '../../../hooks/useMediaBreakpoints';
import { isDarkMode } from 'utils/helpers';
import colors from 'theme/colors';

const ActionContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
});
const OfferActionContainer = styled('div')({
  maxWidth: 'calc(100% - 20px)',
  width: '100%',
  position: 'fixed',
  [breakpoints.up(769)]: {
    padding: '0 10px',
    position: 'relative',
    top: '95px',
    paddingBottom: 83,
  },
  [breakpoints.between(600, 768)]: {
    [MEDIA_SCREEN_HEIGHT_300_450]: {
      padding: '0 10px',
      position: 'relative',
      top: '95px',
      paddingBottom: 83,
    },
  },
});

const OfferLabelInfo = styled('span')(() => ({
  fontSize: 15,
  fontWeight: 400,
  marginRight: 5,
  lineHeight: '20px',
  letterSpacing: '-0.3',
  color: isDarkMode() ? colors.blue['200'] : borders.light.secondary,
}));

const OfferLabelInfoContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: 3,
  [breakpoints.up(769)]: {
    paddingBottom: 83,
  },
  [breakpoints.between(600, 768)]: {
    [MEDIA_SCREEN_HEIGHT_300_450]: {
      paddingBottom: 83,
    },
  },
});

const DashboardDiscoverModeOfferActions: React.FC<Props> = ({
  offerPrice,
  updateOfferPrice,
  swipe,
  hasError,
  currencySymbols,
  ownProfile,
  disableManualClick,
}) => {
  const { offerActionContainerRef, calculateHeightPhotoSlider } = useDashboardDiscoverMode();
  const [bottom, setBottom] = useState(0); // Default value
  const { siteFooterLogoRef } = useApp();
  const { isMobile } = useMediaBreakpoints();

  useEffect(() => {
    const siteFooterLogoEl = siteFooterLogoRef?.current;

    if (siteFooterLogoEl) {
      const siteFooterLogoClRec = siteFooterLogoEl.getBoundingClientRect();
      const OFFER_ACTION_MARGIN_BOTTOM = 15;
      const computeDynamicBottom = window.innerHeight - siteFooterLogoClRec.top + OFFER_ACTION_MARGIN_BOTTOM;

      setBottom(computeDynamicBottom);
    }
  }, [siteFooterLogoRef?.current, isMobile]);

  useEffect(() => {
    //  when bottom values is changed, we need to recalculate the dynamic media ratio
    if (bottom) {
      calculateHeightPhotoSlider();
    }
  }, [bottom]);

  useEffect(() => {
    window.addEventListener('resize', calculateHeightPhotoSlider);
    return () => {
      window.removeEventListener('resize', calculateHeightPhotoSlider);
    };
  }, []);

  return (
    <OfferActionContainer ref={offerActionContainerRef} style={{ bottom }}>
      <ActionContainer>
        <DashboardDiscoverModeOfferActionPass
          isDarkMode={isDarkMode()}
          disableManualClick={disableManualClick}
          onClick={() => swipe('left')}
        />
        <DashboardDiscoverModeOfferActionInput
          offerPrice={offerPrice}
          updateOfferPrice={updateOfferPrice}
          hasError={hasError}
          currencySymbols={currencySymbols}
        />
        <DashboardDiscoverModeOfferActionOffer disableManualClick={disableManualClick} onClick={() => swipe('right')} />
      </ActionContainer>
      <OfferLabelInfoContainer>
        <OfferLabelInfo>First date offer {ownProfile.isAttractive() && 'request'}</OfferLabelInfo>
        <DashboardDiscoverModeWhatsAnOffer />
      </OfferLabelInfoContainer>
    </OfferActionContainer>
  );
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    updateOfferTutorialState: () => {
      dispatch(updateShowTutorialOffer(false));
    },
  };
};

const mapStateToProps = (state: RootState) => {
  return {
    ownProfile: ProfileMaker.create(state.profile.profile),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardDiscoverModeOfferActions);
